import { Collection } from 'modules/core/lib/mobx-rest'

import { employeeReferenceContract } from 'modules/contracts/lib/utils'
import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import type ContractVersion from 'modules/contracts/store/models/ContractVersion'
import type Employee from 'modules/employees/store/models/Employee'
import JobLevel, { Attributes } from 'modules/job_catalog/store/models/JobLevel'
import type JobRole from 'modules/job_catalog/store/models/JobRole'

class JobLevels extends Collection<JobLevel> {
  model() {
    return JobLevel
  }

  archived(filters: Partial<Attributes> = {}) {
    return this.filter({ ...filters, archived: true })
  }

  active(filters: Partial<Attributes> = {}) {
    return this.filter({ ...filters, archived: false })
  }
}

const singleton = new JobLevels()

export const jobRoleLevels = (jobRole: JobRole) => {
  return singleton
    .active({ role_id: jobRole.attributes.id, is_default: false })
    .sort((a, b) => a.attributes.order - b.attributes.order)
}
const jobRoleAllLevels = (jobRole: JobRole) => {
  return singleton
    .filter({ role_id: jobRole.attributes.id })
    .sort((a, b) => a.attributes.order - b.attributes.order)
}

export const jobRoleDefaultLevel = (jobRole: JobRole) => {
  return jobRoleAllLevels(jobRole).find((level) => level.isDefault)
}

export const jobRoleHasAssignableLevels = (jobRole: JobRole) => {
  return jobRoleLevels(jobRole).length > 0
}

export const employeeJobLevel = (contractVersions: ContractVersions, employee: Employee) => {
  const id = employeeReferenceContract(contractVersions, employee)?.jobCatalogLevelId

  return singleton.get(id)
}

export const contractVersionJobLevel = (contractVersion: ContractVersion) => {
  return singleton.get(contractVersion.jobCatalogLevelId)
}

export default singleton
